// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ec47f961","239":"9679cb00","633":"1dba178e","732":"8a8b298b","749":"d5b236bd","903":"595ac6ec"}[chunkId] + ".chunk.js";
};